// File: src/components/invoices/OperationalSummaryCards.jsx

import React from "react";
import { Receipt, CheckCircle, Clock, AlertTriangle } from "lucide-react";

const currency = (n) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  }).format(Number(n || 0));

export default function OperationalSummaryCards({ summary, localSummary }) {
  const count = summary?.count ?? summary?.invoice_count ?? localSummary?.count ?? 0;

  const totalValue =
    summary?.total_value ??
    summary?.gross_invoiced ??
    localSummary?.totalValue ??
    0;

  const paidValue =
    summary?.paid_value ??
    summary?.gross_paid ??
    localSummary?.paidValue ??
    0;

  const openValue =
    summary?.open_value ??
    summary?.outstanding_balance ??
    localSummary?.openValue ??
    0;

  return (
    <div className="grid md:grid-cols-4 gap-4">
      <div className="rounded-xl border border-white/10 bg-[#101010] p-4">
        <div className="flex items-center gap-2 text-gray-400 text-xs">
          <Receipt className="w-4 h-4" />
          Invoices
        </div>
        <div className="text-xl font-bold mt-1">{count}</div>
      </div>

      <div className="rounded-xl border border-white/10 bg-[#101010] p-4">
        <div className="flex items-center gap-2 text-gray-400 text-xs">
          <CheckCircle className="w-4 h-4" />
          Total Value
        </div>
        <div className="text-xl font-bold mt-1">{currency(totalValue)}</div>
      </div>

      <div className="rounded-xl border border-white/10 bg-[#101010] p-4">
        <div className="flex items-center gap-2 text-gray-400 text-xs">
          <Clock className="w-4 h-4" />
          Paid Value
        </div>
        <div className="text-xl font-bold text-green-300 mt-1">
          {currency(paidValue)}
        </div>
      </div>

      <div className="rounded-xl border border-white/10 bg-[#101010] p-4">
        <div className="flex items-center gap-2 text-gray-400 text-xs">
          <AlertTriangle className="w-4 h-4" />
          Open / Remaining
        </div>
        <div className="text-xl font-bold text-amber-300 mt-1">
          {currency(openValue)}
        </div>
      </div>
    </div>
  );
}